import { MUTATIONS, STATE } from "./names";
import type { State } from "./types";

export default {
    [MUTATIONS.SET_IS_UPGRADING_TO_AFFILIATE](state: State, isUpgradeToAffiliatePopupVisible: boolean) {
        state[STATE.IS_UPGRADING_TO_AFFILIATE] = isUpgradeToAffiliatePopupVisible;
    },
}